import * as React from 'react';
import Observer from 'react-intersection-observer';
import { withSiteData } from 'react-static';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Dispatch } from 'redux';

import { closeNav, openNav, NavState, setScrolled, toggleNav } from './navDuck';
import { Language } from '../Localization/localizationDuck';
import NavComponent from '../../components/Nav/Nav';
import { SiteProps } from '../../SiteProps';
import { RootState } from '../../RootState';
import { RootAction } from '../../RootAction';

interface StateProps extends NavState {
  language: Language;
}

interface DispatchProps {
  openNav: () => void;
  closeNav: () => void;
  toggleNav: () => void;
  setScrolled: (isScrolled: boolean) => void;
}

interface NavProps extends StateProps, DispatchProps, SiteProps {
  language: Language;
}

const Nav: React.SFC<NavProps> = props => (
  <div>
    <Observer threshold={1} onChange={(inView: boolean) => props.setScrolled(!inView)}>
      <div />
    </Observer>
    <NavComponent
      isOpened={props.isOpened}
      onToggleMenu={props.toggleNav}
      onCloseMenu={props.closeNav}
      onLinkClick={props.closeNav}
      locale={props.navLocale[props.language]}
    />
  </div>
);

const mapStateToProps = (state: RootState): StateProps => ({
  language: state.localization.language,
  isOpened: state.nav.isOpened,
  isScrolled: state.nav.isScrolled,
  openedSubMenu: state.nav.openedSubMenu,
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>): DispatchProps => ({
  openNav: () => dispatch(openNav()),
  toggleNav: () => dispatch(toggleNav()),
  closeNav: () => dispatch(closeNav()),
  setScrolled: (isScrolled: boolean) => dispatch(setScrolled(isScrolled)),
});

export default withRouter(
  withSiteData(
    connect<StateProps, DispatchProps, {}, RootState>(
      mapStateToProps,
      mapDispatchToProps,
    )(Nav),
  ),
);



// WEBPACK FOOTER //
// /www/client/src/containers/Nav/Nav.tsx